import { FcCalendar, FcCheckmark, FcList } from 'react-icons/fc';
import { Alert } from '@/components/ui/alert';
import { useI18n } from 'src/i18n/I18nContext';
import { OverallBudget } from 'src/api/OverallBudget';
import { AmountUtil } from 'src/data/AmountUtil';
import { useOrganization } from 'src/auth/AuthContext';
import {
    StepsItem,
    StepsList,
    StepsRoot,
} from "@/components/ui/steps"

const HorizontalTimeline = ({ events }: { events: OverallBudget[] }) => {
    const { t } = useI18n();
    const organization = useOrganization();
    const currency = organization?.currency ?? events[0]?.budget.currency;
    const steps = events.filter(e => e.year > 2019);
    const currentYear = new Date().getFullYear();
    const currentIndex = Math.max(0, steps.findIndex(e => e.year === currentYear)); // doesn't allow -1 the step component


    return (
        <StepsRoot step={currentIndex} count={steps.length} colorPalette='green'>
            <StepsList>
                {steps.map((step, index) => (
                    <StepsItem index={index} 
                        title={step.year}
                        key={`timeline-${index}`}
                        description={`${AmountUtil.format(step.budget.value)} ${step.budget.currency}`}
                        icon={index < currentIndex ? <FcCheckmark /> : index > currentIndex ? <FcList /> : <FcCalendar />}
                        css={index > currentIndex ? {
                            '& [data-part="indicator"]': {
                                background: 'colorPalette.solid/20',
                                borderColor: 'colorPalette.solid',
                            },
                        } : undefined}
                    >
                    </StepsItem>
                ))}
            </StepsList>
            {currency && <Alert status='info' size='sm' borderRadius='md'
                borderStartWidth="3px" borderStartColor="colorPalette.600">
                {t('landing.timeline.budgetInfo', { currency })}
            </Alert>}
        </StepsRoot>
    );
};

export default HorizontalTimeline;
